import React from "react";

const Thumbnails = ({ totalPages, currentPage, onSelectPage, thumbRefs, isSidebarOpen, listRef }) => {
  if (!isSidebarOpen) return null;
  return (
    <div className="pdf-thumbnails" ref={listRef}>
      {Array.from({ length: totalPages }).map((_, idx) => (
        <div
          key={idx}
          className={`pdf-thumb ${currentPage === idx + 1 ? "active" : ""}`}
          onClick={() => onSelectPage(idx + 1)}
        >
          <canvas ref={thumbRefs.current[idx]} className="pdf-thumb-canvas" />
        </div>
      ))}
    </div>
  );
};

export default Thumbnails;

